import * as React from "react";
const SvgRadioButtonChecked = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
  fill: "currentColor"
}));
export default SvgRadioButtonChecked;